module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "countdown",
    style: ({
      'color': _vm.color
    })
  }, [(_vm.days > 0) ? _c('span', [_vm._v(_vm._s(_vm.days) + " days")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.hours) + ":" + _vm._s(_vm.minutes)), (_vm.seconds) ? _c('span', [_vm._v(":" + _vm._s(_vm.seconds))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cb49fd48!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/countdown/CountdownTimer.vue
// module id = 2129
// module chunks = 2